export function decideFavIcon(isTruink) {
  // Default favicon
  let iconUrl =
    "https://storage.googleapis.com/content_ai_bucket_elhitech/content/21.png";

  if (typeof isTruink === "undefined") {
    if (window.location.hostname.startsWith("tap")) {
      iconUrl =
        "https://storage.googleapis.com/content_ai_bucket_elhitech/content/Heading%20(6).png";
    }
  } else {
    if (isTruink) {
      iconUrl =
        "https://storage.googleapis.com/content_ai_bucket_elhitech/content/20.png";
    } else {
      iconUrl =
        "https://storage.googleapis.com/content_ai_bucket_elhitech/content/21.png";
    }
  }

  changeFavicon(iconUrl);
}

function changeFavicon(iconUrl) {

  document
    .querySelectorAll("link[rel*='icon']")
    .forEach((icon) => icon.remove());

  const link = document.createElement("link");
  link.rel = "icon";
  link.type = "image/png";
  link.href = iconUrl;

  document.head.appendChild(link);
}